import { ISelectOption } from '../interfaces/select-option.interface';

export const HORIZONTAL_POSITION_OPTIONS: ISelectOption[] = [
  { key: 'start', name: 'Left' },
  { key: 'end', name: 'Right' },
];
